export type ArticleCategory = "news" | "recommendations" | "stars";

export interface Article {
  id: string;
  title: string;
  category: ArticleCategory;
  categoryName: string;
  summary: string;
  cover: string;
  author: string;
  source: string;
  publishedAt: string;
  views: number;
  tags: string[];
  featured?: boolean;
  content: string[];
}

export interface CategoryMeta {
  slug: ArticleCategory;
  name: string;
  title: string;
  description: string;
  intro: string;
  icon: string;
}

export const categoryMeta: Record<ArticleCategory, CategoryMeta> = {
  news: {
    slug: "news",
    name: "娱乐资讯",
    title: "娱乐资讯 - 蜜桃33",
    description:
      "蜜桃33娱乐资讯频道，实时汇总最新影视、音乐、综艺与行业动态，帮你快速掌握娱乐热点。",
    intro:
      "聚合影视、音乐、综艺与行业要闻，以编辑视角筛选值得关注的娱乐动态，让你用更少时间读懂今天发生了什么。",
    icon: "ri-newspaper-line",
  },
  recommendations: {
    slug: "recommendations",
    name: "影视推荐",
    title: "影视推荐 - 蜜桃33",
    description:
      "蜜桃33影视推荐频道，精选电影与电视剧，覆盖多种类型与年代，帮你发现值得一看的优质作品。",
    intro:
      "由编辑团队带来的观影清单，从口碑佳作到话题新片，按类型、年代与评分多维筛选，帮你快速找到下一个想看的作品。",
    icon: "ri-film-line",
  },
  stars: {
    slug: "stars",
    name: "明星动态",
    title: "明星动态 - 蜜桃33",
    description:
      "蜜桃33明星动态频道，追踪热门明星最新报道与行程，第一时间了解你关注的明星近况。",
    intro:
      "关注演员、歌手与创作人的最新行程与作品动向，用简洁的报道呈现明星台前幕后的真实状态。",
    icon: "ri-star-smile-line",
  },
};

export const articles: Article[] = [
  {
    id: "n1",
    title: "年度影视盛典提名名单揭晓 多部现实题材作品入围",
    category: "news",
    categoryName: "娱乐资讯",
    summary:
      "本届影视盛典公布完整提名名单，现实题材与女性视角作品成为最大赢家，多部新锐导演的首部长片成功入围。",
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20entertainment%20magazine%20scene%20of%20a%20grand%20awards%20ceremony%20stage%20with%20warm%20golden%20spotlights%2C%20elegant%20red%20carpet%20and%20soft%20bokeh%2C%20cinematic%20warm%20lighting%2C%20clean%20harmonious%20background%2C%20high%20detail%20photography&width=1200&height=800&seq=mitao33-news-01&orientation=landscape",
    author: "编辑部",
    source: "蜜桃33 影评组",
    publishedAt: "2026-10-11",
    views: 28640,
    tags: ["影视盛典", "提名", "现实题材"],
    featured: true,
    content: [
      "备受关注的年度影视盛典于本周公布了完整提名名单。从入围结果来看，现实题材作品延续了近几年的强势表现，在最佳影片、最佳导演与最佳编剧等重量级奖项中占据过半名额。",
      "值得关注的是，本届有多位新锐导演凭借首部长片直接入围最佳导演，成为名单中最大的惊喜。评审团在说明中提到，今年的评选更看重作品与当下生活的连接感，以及创作者在叙事语言上的探索。",
      "在表演类奖项方面，多位常年活跃在舞台剧领域的演员首次进入大众视野，也让观众对最终的颁奖结果充满期待。完整获奖名单将于下月正式揭晓。",
    ],
  },
  {
    id: "n2",
    title: "暑期档票房刷新纪录 国产科幻与动画双线领跑",
    category: "news",
    categoryName: "娱乐资讯",
    summary:
      "今年暑期档总票房创下同期新高，国产科幻与合家欢动画成为拉动大盘的两大主力，多部影片实现口碑逆袭。",
    cover:
      "https://readdy.ai/api/search-image?query=modern%20cinema%20marquee%20at%20dusk%20with%20warm%20amber%20lights%2C%20minimalist%20urban%20street%2C%20soft%20glow%20and%20clean%20composition%2C%20cinematic%20warm%20tone%2C%20editorial%20photography%2C%20high%20detail%2C%20harmonious%20color%20palette&width=1200&height=800&seq=mitao33-news-02&orientation=landscape",
    author: "数据组",
    source: "蜜桃33 票房观察",
    publishedAt: "2026-10-10",
    views: 41230,
    tags: ["暑期档", "票房", "国产科幻"],
    featured: true,
    content: [
      "随着最后一部主推影片下映，今年暑期档正式收官。统计数据显示，档期总票房刷新同期纪录，观影人次也实现稳中有升，为全年市场注入了一剂强心针。",
      "从类型分布看，国产科幻与合家欢动画构成了拉动大盘的双引擎。科幻题材依靠成熟的特效工业与更接地气的故事设定赢得口碑，而动画作品则凭借稳定的家庭客群实现了长线发酵。",
      "多部上映初期排片不占优势的影片，依靠社交平台的口碑扩散完成了票房逆袭。业内人士认为，内容质量与观众自发传播正在成为决定影片生命周期的关键变量。",
    ],
  },
  {
    id: "n3",
    title: "城市音乐节官宣阵容 三十组音乐人将开启三城巡演",
    category: "news",
    categoryName: "娱乐资讯",
    summary:
      "年度城市音乐节公布首批阵容，涵盖民谣、摇滚与电子等风格，将在三座城市连续举办，门票分阶段开售。",
    cover:
      "https://readdy.ai/api/search-image?query=outdoor%20music%20festival%20stage%20at%20golden%20hour%20with%20warm%20amber%20stage%20lights%20and%20crowd%20silhouettes%2C%20dreamy%20warm%20haze%2C%20cinematic%20warm%20lighting%2C%20editorial%20photography%2C%20clean%20harmonious%20background&width=1200&height=800&seq=mitao33-news-03&orientation=landscape",
    author: "演出组",
    source: "蜜桃33 现场",
    publishedAt: "2026-10-09",
    views: 19380,
    tags: ["音乐节", "演出", "巡演"],
    content: [
      "主办方今日公布年度城市音乐节的首批阵容，三十组音乐人将横跨民谣、摇滚与电子等风格，在为期三个月的时间里完成三座城市的巡演。",
      "与往年不同，本届音乐节将增加更多下午场次，让观众能在自然光下感受不同风格乐队的现场。主办方表示，希望把音乐节办成一场可以慢慢逛、慢慢听的户外聚会。",
      "门票将于下周分阶段开售，其中早鸟票与单日票将同步上线。为照顾跨城观众，主办方还联合交通部门推出了演出日的加开班次信息。",
    ],
  },
  {
    id: "n4",
    title: "慢综艺新一季定档 治愈系旅居生活再度回归",
    category: "news",
    categoryName: "娱乐资讯",
    summary:
      "备受好评的慢综艺公布新一季定档信息，本季将走进海边小镇与山间村落，用日常视角记录嘉宾的旅居生活。",
    cover:
      "https://readdy.ai/api/search-image?query=cozy%20seaside%20small%20town%20guesthouse%20terrace%20at%20soft%20sunset%20with%20warm%20amber%20light%2C%20calm%20minimalist%20interior%20details%2C%20cinematic%20warm%20tone%2C%20editorial%20photography%2C%20high%20detail&width=1200&height=800&seq=mitao33-news-04&orientation=landscape",
    author: "综艺组",
    source: "蜜桃33 综艺观察",
    publishedAt: "2026-10-08",
    views: 15870,
    tags: ["慢综艺", "定档", "旅居"],
    content: [
      "以治愈氛围著称的慢综艺今日官宣新一季定档，本季节目组将镜头对准海边小镇与山间村落，记录嘉宾放下行程表之后的真实日常。",
      "节目制作人表示，新一季减少了任务与规则，更多依赖嘉宾之间的自然互动，希望通过缓慢的节奏为观众提供一种可以放松的观看体验。",
      "在嘉宾阵容上，本季既保留了观众熟悉的老朋友，也加入了几位首次参与慢综艺的新面孔，代际之间的相处成为新的看点。",
    ],
  },
  {
    id: "n5",
    title: "影视基地开放日启动 幕后制作流程首次对公众展示",
    category: "news",
    categoryName: "娱乐资讯",
    summary:
      "多家影视基地联合发起开放日活动，观众可近距离参观摄影棚、道具库与后期机房，了解一部作品从零到一的过程。",
    cover:
      "https://readdy.ai/api/search-image?query=film%20studio%20backlot%20with%20warm%20amber%20work%20lights%2C%20camera%20rig%20and%20prop%20shelves%2C%20clean%20industrial%20studio%20space%2C%20cinematic%20warm%20tone%2C%20editorial%20photography%2C%20high%20detail&width=1200&height=800&seq=mitao33-news-05&orientation=landscape",
    author: "产业组",
    source: "蜜桃33 产业观察",
    publishedAt: "2026-10-07",
    views: 11240,
    tags: ["影视基地", "幕后", "开放日"],
    content: [
      "多家影视基地联合发起为期两周的开放日活动，公众可以预约参观摄影棚、道具库、服装间与后期机房，近距离了解影视制作的真实流程。",
      "在道具库中，参观者可以看到从年代家具到科幻装置在内的各类藏品，工作人员会现场讲解道具设计如何服务于角色与故事。",
      "主办方表示，希望开放日能让更多人理解影视行业是一个庞大的协作系统，也让有兴趣进入行业的年轻人找到了解入口。",
    ],
  },
  {
    id: "n6",
    title: "悬疑剧《雾都来信》开播 口碑走高登顶话题榜",
    category: "news",
    categoryName: "娱乐资讯",
    summary:
      "原创悬疑剧《雾都来信》首播即登上话题榜前列，紧凑的叙事与电影级影像质感成为观众讨论的焦点。",
    cover:
      "https://readdy.ai/api/search-image?query=moody%20rainy%20old%20city%20street%20at%20night%20with%20warm%20amber%20street%20lamps%20and%20wet%20reflections%2C%20mysterious%20cinematic%20atmosphere%2C%20warm%20cool%20contrast%2C%20editorial%20photography%2C%20high%20detail&width=1200&height=800&seq=mitao33-news-06&orientation=landscape",
    author: "剧评组",
    source: "蜜桃33 剧集观察",
    publishedAt: "2026-10-06",
    views: 33450,
    tags: ["悬疑剧", "开播", "口碑"],
    featured: true,
    content: [
      "原创悬疑剧《雾都来信》于本周正式开播，首更两集后迅速登上社交平台话题榜前列，弹幕与讨论区对开篇的节奏处理给出了较高评价。",
      "该剧以一座常年多雾的旧城为背景，通过一封来历不明的信件牵出跨越数年的往事。导演在采访中提到，剧组刻意保留了大量环境声与长镜头，希望让观众沉浸在城市本身的呼吸里。",
      "在表演层面，几位主演收敛克制的演绎被认为与剧集气质高度契合。随着故事进入中段，后续走向能否维持开局水准，成为观众关注的重点。",
    ],
  },
  {
    id: "n7",
    title: "自然纪录片《山河四季》上线 4K 镜头记录中国生态",
    category: "news",
    categoryName: "娱乐资讯",
    summary:
      "历时三年拍摄的自然纪录片《山河四季》正式上线，用 4K 镜头呈现跨越四季的自然生态与珍稀物种。",
    cover:
      "https://readdy.ai/api/search-image?query=breathtaking%20mountain%20landscape%20across%20four%20seasons%20with%20warm%20sunrise%20light%2C%20misty%20valleys%20and%20clean%20harmonious%20tones%2C%20cinematic%20warm%20color%20grading%2C%20editorial%20nature%20photography%2C%20high%20detail&width=1200&height=800&seq=mitao33-news-07&orientation=landscape",
    author: "纪录片组",
    source: "蜜桃33 纪录片观察",
    publishedAt: "2026-10-05",
    views: 14060,
    tags: ["纪录片", "生态", "4K"],
    content: [
      "历时三年拍摄的自然纪录片《山河四季》正式上线，摄制组辗转多地，用 4K 镜头记录下跨越四季的自然生态与多种珍稀物种的日常。",
      "纪录片以季节为章节结构，从春天的融雪到冬日的迁徙，讲述自然环境中生物与气候之间的相互依存关系。摄制团队采用了大量延时与微距拍摄手法。",
      "为减少对野生动物的干扰，剧组全程遵循拍摄伦理规范，并与当地保护机构合作完成取景。片中部分罕见画面为首次公开。",
    ],
  },
  {
    id: "r1",
    title: "《雾都来信》",
    category: "recommendations",
    categoryName: "影视推荐",
    summary:
      "一座常年多雾的旧城，一封来历不明的信件，牵引出跨越数年的往事。叙事克制、影像质感出色的原创悬疑剧。",
    cover:
      "https://readdy.ai/api/search-image?query=minimalist%20cinematic%20movie%20poster%20of%20a%20misty%20old%20city%20street%20with%20a%20single%20warm%20amber%20lamp%2C%20mysterious%20mood%2C%20warm%20tone%20grading%2C%20clean%20elegant%20composition%2C%20editorial%20design%2C%20high%20detail&width=800&height=1200&seq=mitao33-rec-01&orientation=portrait",
    author: "影评组",
    source: "蜜桃33 影视推荐",
    publishedAt: "2026-10-11",
    views: 52110,
    tags: ["悬疑", "剧情", "2026"],
    featured: true,
    content: [
      "推荐理由：如果你喜欢慢热但后劲很足的悬疑叙事，《雾都来信》值得放进片单。它不依赖密集的反转，而是把悬念藏进城市的雾气与人物沉默的间隙里。",
      "剧集在影像上给了旧城足够的呼吸空间，长镜头与自然光让人几乎忘记这是一部类型剧。表演层面，几位主演收得很住，情绪都藏在细节里。",
      "适合人群：喜欢氛围感、愿意跟着故事慢慢走的观众。观看建议是一次看两集，配上一杯热饮，节奏会刚刚好。",
    ],
  },
  {
    id: "r2",
    title: "《银河旅人》",
    category: "recommendations",
    categoryName: "影视推荐",
    summary:
      "一趟驶向深空的漫长旅程，一群在孤独中学会告别的人。国产科幻在工业质感与情感表达之间的平衡之作。",
    cover:
      "https://readdy.ai/api/search-image?query=minimalist%20sci%20fi%20movie%20poster%20of%20a%20solitary%20spaceship%20crossing%20a%20warm%20nebula%2C%20soft%20amber%20and%20deep%20indigo%20space%20tone%2C%20clean%20elegant%20composition%2C%20editorial%20design%2C%20high%20detail&width=800&height=1200&seq=mitao33-rec-02&orientation=portrait",
    author: "影评组",
    source: "蜜桃33 影视推荐",
    publishedAt: "2026-10-10",
    views: 47890,
    tags: ["科幻", "冒险", "2026"],
    featured: true,
    content: [
      "推荐理由：国产科幻在《银河旅人》里找到了一种更安静的表达方式。影片没有把重心放在宏大的对抗上，而是让一群孤独的人在漫长航行中学习告别与和解。",
      "飞船内景与外星场景的美术设计颇具巧思，暖色调的舱内灯光与冷色宇宙形成对比，视觉上既未来又不失温度。",
      "适合人群：偏爱人文科幻、愿意为情绪买单的观众。散场后建议留一会儿，片尾的留白值得回味。",
    ],
  },
  {
    id: "r3",
    title: "《人间烟火录》",
    category: "recommendations",
    categoryName: "影视推荐",
    summary:
      "以一条老巷子里的早餐铺为中心，串联起街坊邻居的日常与悲欢。温暖、细碎，却格外治愈的生活剧。",
    cover:
      "https://readdy.ai/api/search-image?query=minimalist%20movie%20poster%20of%20a%20cozy%20old%20alley%20breakfast%20shop%20with%20warm%20steam%20and%20amber%20morning%20light%2C%20warm%20harmonious%20tone%2C%20clean%20elegant%20composition%2C%20editorial%20design%2C%20high%20detail&width=800&height=1200&seq=mitao33-rec-03&orientation=portrait",
    author: "生活组",
    source: "蜜桃33 影视推荐",
    publishedAt: "2026-10-09",
    views: 39870,
    tags: ["都市", "生活", "治愈"],
    content: [
      "推荐理由：这是一部适合在夜里慢慢看的剧。故事发生在一条老巷子的早餐铺里，老板与街坊的日常被拍得细碎又真实，几乎没有刻意煽情。",
      "剧组对市井细节的还原值得称道：清晨的蒸汽、老旧的招牌、邻里之间不经意的关照，共同撑起了一个有温度的小世界。",
      "适合人群：喜欢生活流叙事、想找一部能安放心情作品的观众。配着早餐一起看，效果加倍。",
    ],
  },
  {
    id: "r4",
    title: "《深海回声》",
    category: "recommendations",
    categoryName: "影视推荐",
    summary:
      "一支科考队深入未知海域，在幽暗的深蓝中发现意料之外的信号。紧张感与视觉奇观兼备的冒险电影。",
    cover:
      "https://readdy.ai/api/search-image?query=minimalist%20movie%20poster%20of%20a%20deep%20ocean%20submersible%20descending%20into%20dark%20blue%20water%20with%20a%20single%20warm%20amber%20light%20beam%2C%20clean%20elegant%20composition%2C%20editorial%20design%2C%20high%20detail&width=800&height=1200&seq=mitao33-rec-04&orientation=portrait",
    author: "影评组",
    source: "蜜桃33 影视推荐",
    publishedAt: "2026-10-08",
    views: 30540,
    tags: ["冒险", "科幻", "悬疑"],
    content: [
      "推荐理由：《深海回声》把紧张感留在了黑暗与沉默里。一支科考队深入未知海域，随着下潜深度的增加，声音与光线都逐渐变得不再可靠。",
      "影片在声音设计上下了很大功夫，深海的低频轰鸣与突然的寂静交替出现，让观众始终处于一种被包裹的紧张之中。",
      "适合人群：喜欢深海题材与悬疑氛围的观众。建议在音效好的环境中观看，体验会完全不同。",
    ],
  },
  {
    id: "r5",
    title: "《山海旧梦》",
    category: "recommendations",
    categoryName: "影视推荐",
    summary:
      "取材自民间传说，讲述一位画师与山中精怪之间的约定。美术考究、节奏舒缓的古装奇幻剧。",
    cover:
      "https://readdy.ai/api/search-image?query=minimalist%20ancient%20chinese%20fantasy%20movie%20poster%20of%20misty%20mountains%20with%20a%20lone%20scholar%20figure%20and%20warm%20lantern%20light%2C%20ink%20painting%20tone%2C%20clean%20elegant%20composition%2C%20editorial%20design%2C%20high%20detail&width=800&height=1200&seq=mitao33-rec-05&orientation=portrait",
    author: "古装组",
    source: "蜜桃33 影视推荐",
    publishedAt: "2026-10-07",
    views: 28760,
    tags: ["古装", "奇幻", "爱情"],
    content: [
      "推荐理由：《山海旧梦》把奇幻藏在山水之间。故事取材自民间传说，讲述一位画师与山中精怪之间的约定，节奏舒缓，适合静下心来欣赏。",
      "美术与服化道是这部剧的一大亮点，画面借鉴了水墨长卷的构图方式，色彩克制而雅致，几乎每一帧都可以停下来细看。",
      "适合人群：喜欢东方美学与慢节奏奇幻故事的观众。配合原著故事一起看，会有更多发现。",
    ],
  },
  {
    id: "r6",
    title: "《午后咖啡馆》",
    category: "recommendations",
    categoryName: "影视推荐",
    summary:
      "在一家街角咖啡馆里，不同的人生故事因一杯咖啡而交汇。节奏轻快、台词有趣的都市爱情小品。",
    cover:
      "https://readdy.ai/api/search-image?query=minimalist%20romantic%20movie%20poster%20of%20a%20cozy%20corner%20cafe%20table%20with%20warm%20afternoon%20sunlight%20and%20a%20coffee%20cup%2C%20soft%20amber%20tone%2C%20clean%20elegant%20composition%2C%20editorial%20design%2C%20high%20detail&width=800&height=1200&seq=mitao33-rec-06&orientation=portrait",
    author: "都市组",
    source: "蜜桃33 影视推荐",
    publishedAt: "2026-10-06",
    views: 26310,
    tags: ["爱情", "都市", "轻喜剧"],
    content: [
      "推荐理由：这是一部看完会想去楼下咖啡馆坐一会儿的电影。故事在一家街角咖啡馆里展开，不同的人生片段因为一杯咖啡产生交集。",
      "台词是这部片最讨喜的部分，幽默里带着一点温度，不刻意讨好也不故作深沉，很多细节都来自真实的生活观察。",
      "适合人群：喜欢都市小品与轻喜剧的观众。周末午后观看，与影片气质最搭。",
    ],
  },
  {
    id: "r7",
    title: "《都市漫游者》",
    category: "recommendations",
    categoryName: "影视推荐",
    summary:
      "一个深夜城市里的送餐员，一辆老旧的自行车，一段被重新看见的城市地图。细腻的都市剧情片。",
    cover:
      "https://readdy.ai/api/search-image?query=minimalist%20movie%20poster%20of%20a%20cyclist%20riding%20through%20a%20night%20city%20with%20warm%20amber%20street%20lights%20and%20motion%20blur%2C%20cinematic%20warm%20tone%2C%20clean%20elegant%20composition%2C%20editorial%20design%2C%20high%20detail&width=800&height=1200&seq=mitao33-rec-07&orientation=portrait",
    author: "影评组",
    source: "蜜桃33 影视推荐",
    publishedAt: "2026-10-05",
    views: 22980,
    tags: ["剧情", "都市", "现实"],
    content: [
      "推荐理由：《都市漫游者》跟着一位深夜送餐员穿过城市的街巷，用骑行速度重新丈量了一座被我们忽略的城市地图。",
      "影片没有把镜头对准戏剧性的冲突，而是耐心记录那些发生在凌晨的微小瞬间：亮着的窗口、路边的小摊、等红灯时抬头看到的月亮。",
      "适合人群：喜欢现实主义风格、愿意在平凡细节里寻找共鸣的观众。建议独自观看，更容易沉浸。",
    ],
  },
  {
    id: "s1",
    title: "林知夏新剧杀青 坦言挑战高难度长镜头是全新体验",
    category: "stars",
    categoryName: "明星动态",
    summary:
      "演员林知夏主演的新剧正式杀青，她在采访中分享了拍摄长镜头戏份的挑战，并透露会在休息一段时间后投入下一部作品。",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20backstage%20scene%20of%20a%20film%20set%20with%20amber%20lighting%2C%20director%20chair%20and%20clapperboard%2C%20clean%20elegant%20minimalist%20background%2C%20cinematic%20warm%20tone%2C%20editorial%20photography%2C%20high%20detail&width=1200&height=800&seq=mitao33-star-01&orientation=landscape",
    author: "星闻组",
    source: "蜜桃33 明星动态",
    publishedAt: "2026-10-11",
    views: 21030,
    tags: ["林知夏", "新剧", "杀青"],
    featured: true,
    content: [
      "演员林知夏主演的新剧于本周正式杀青。剧组发布的概念物料显示，这部剧将采用大量长镜头拍摄，对演员的走位与情绪连续性要求很高。",
      "林知夏在采访中坦言，连续拍摄十分钟不喊停的长镜头是一次全新体验，她为此提前一个月进组排练，「像是重新学了一次表演」。",
      "谈及接下来的计划，她表示会先休息一段时间，调整状态之后再挑选下一部作品，并希望尝试更多不同类型的角色。",
    ],
  },
  {
    id: "s2",
    title: "苏逸然首次担任制片人 全新题材电影进入筹备阶段",
    category: "stars",
    categoryName: "明星动态",
    summary:
      "演员苏逸然确认以制片人身份参与一部现实题材电影，他表示希望在镜头之外，从另一个角度理解电影如何诞生。",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20film%20production%20office%20meeting%20scene%20with%20script%20notes%20and%20amber%20desk%20lamp%2C%20clean%20minimalist%20interior%2C%20cinematic%20warm%20tone%2C%20editorial%20photography%2C%20high%20detail&width=1200&height=800&seq=mitao33-star-02&orientation=landscape",
    author: "星闻组",
    source: "蜜桃33 明星动态",
    publishedAt: "2026-10-10",
    views: 18760,
    tags: ["苏逸然", "制片人", "新片"],
    content: [
      "演员苏逸然确认将以制片人的身份参与一部现实题材电影的筹备工作。这是他首次在镜头之外深度介入一部作品的从零到一。",
      "他表示，做演员时更多关注角色本身，而担任制片人之后，开始理解预算、周期与团队协作如何共同决定一部电影的模样，「像是换了一个视角重新认识电影」。",
      "该片目前处于剧本打磨阶段，预计明年进入拍摄。苏逸然透露，他也会在片中出演一个戏份不重的角色。",
    ],
  },
  {
    id: "s3",
    title: "顾南川音乐新专辑进入混音阶段 预告将启动小型巡演",
    category: "stars",
    categoryName: "明星动态",
    summary:
      "唱作人顾南川透露新专辑已进入最后混音阶段，并计划在专辑发布后启动一轮小型巡演，把更多场地留给近距离的现场交流。",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20recording%20studio%20scene%20with%20mixer%20console%20and%20amber%20accent%20lighting%2C%20acoustic%20guitar%20in%20soft%20focus%2C%20clean%20minimalist%20interior%2C%20cinematic%20warm%20tone%2C%20editorial%20photography&width=1200&height=800&seq=mitao33-star-03&orientation=landscape",
    author: "音乐组",
    source: "蜜桃33 明星动态",
    publishedAt: "2026-10-09",
    views: 16240,
    tags: ["顾南川", "音乐", "巡演"],
    content: [
      "唱作人顾南川在社交平台透露，新专辑已进入最后的混音阶段，整体风格会比上一张更简洁，编曲上留出了更多空间感。",
      "他同时预告，专辑发布后将启动一轮小型巡演，选择更小的场地，把注意力放回音乐与观众的近距离交流上。",
      "据团队介绍，这次巡演会保留部分不插电曲目，也会有首次现场演出专辑中的新歌。门票信息将在专辑上线后公布。",
    ],
  },
  {
    id: "s4",
    title: "沈清和话剧舞台回归 用两个月时间重新打磨台词",
    category: "stars",
    categoryName: "明星动态",
    summary:
      "演员沈清和宣布回归话剧舞台，将在一部经典剧目中出演重要角色，为此提前两个月进入排练厅打磨台词与走位。",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20theatre%20stage%20rehearsal%20scene%20with%20amber%20spotlight%20and%20empty%20seats%2C%20clean%20elegant%20minimalist%20space%2C%20cinematic%20warm%20tone%2C%20editorial%20photography%2C%20high%20detail&width=1200&height=800&seq=mitao33-star-04&orientation=landscape",
    author: "舞台组",
    source: "蜜桃33 明星动态",
    publishedAt: "2026-10-08",
    views: 13920,
    tags: ["沈清和", "话剧", "舞台"],
    content: [
      "演员沈清和宣布回归话剧舞台，将在一部经典剧目中出演重要角色。为准备这次演出，他提前两个月进入排练厅，重新打磨台词与走位。",
      "他在采访中提到，舞台没有剪辑与重来，每一场都要用完整的能量面对观众，这种紧张感正是他重回舞台的原因。",
      "该剧将在年底开启为期一个月的驻场演出，具体场次与开票时间将由主办方另行公布。",
    ],
  },
  {
    id: "s5",
    title: "江晚舟挑战全新角色类型 为角色减重并进行方言训练",
    category: "stars",
    categoryName: "明星动态",
    summary:
      "演员江晚舟为新片中的角色进行了为期数月的准备，包括减重与方言训练，希望让人物更贴近真实生活的质感。",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20minimalist%20training%20room%20scene%20with%20wooden%20floor%20and%20soft%20amber%20daylight%2C%20clean%20elegant%20background%2C%20cinematic%20warm%20tone%2C%20editorial%20photography%2C%20high%20detail&width=1200&height=800&seq=mitao33-star-05&orientation=landscape",
    author: "星闻组",
    source: "蜜桃33 明星动态",
    publishedAt: "2026-10-07",
    views: 12480,
    tags: ["江晚舟", "新片", "角色"],
    content: [
      "演员江晚舟为新片中的角色进行了为期数月的准备。据剧组透露，她为贴近人物形象调整了体重，并系统学习了角色所在地的方言。",
      "她在采访中表示，方言不只是口音，还包含一整套表达习惯与生活逻辑，只有把它说顺了，人物才会真正站得住。",
      "该片预计明年上半年与观众见面，目前仍在后期制作阶段。",
    ],
  },
  {
    id: "s6",
    title: "裴以安加盟公益短片计划 关注乡村儿童阅读",
    category: "stars",
    categoryName: "明星动态",
    summary:
      "演员裴以安宣布加盟一项公益短片计划，用镜头记录乡村儿童的阅读故事，并呼吁更多人关注基层阅读资源。",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20sunlit%20rural%20classroom%20with%20wooden%20desks%20and%20a%20small%20bookshelf%2C%20soft%20amber%20afternoon%20light%2C%20clean%20harmonious%20tone%2C%20cinematic%20warm%20photography%2C%20editorial%20style%2C%20high%20detail&width=1200&height=800&seq=mitao33-star-06&orientation=landscape",
    author: "公益组",
    source: "蜜桃33 明星动态",
    publishedAt: "2026-10-06",
    views: 10970,
    tags: ["裴以安", "公益", "阅读"],
    content: [
      "演员裴以安宣布加盟一项公益短片计划，与其他创作者一起走进乡村校园，用镜头记录孩子们与书相遇的日常。",
      "他表示，这次拍摄让他重新理解了阅读对成长的意义，也希望短片播出后能让更多人关注基层的阅读资源建设。",
      "该系列短片将在多个平台陆续发布，相关内容也将配合线下的图书捐赠活动同步展开。",
    ],
  },
];

export const hotTags: string[] = [
  "影视盛典",
  "暑期档",
  "悬疑剧",
  "国产科幻",
  "音乐节",
  "慢综艺",
  "纪录片",
  "话剧",
];